import setShippingMethod from './setShippingMethod';

export default setShippingMethod;
